import {
  ALL_TRANSPORT_MODES_DE_SELECTED,
  ALL_TRANSPORT_MODES_SELECTED,
  TRANSPORT_MODE_SELECTED,
} from './types/TransportModeActionTypes';

export function transportModeSelected(legCode, selected) {
  return {
    type: TRANSPORT_MODE_SELECTED,
    legCode,
    selected,
  };
}

export function selectAllTransportModes(legCode) {
  return {
    type: ALL_TRANSPORT_MODES_SELECTED,
    legCode,
  };
}

export function deSelectAllTransportModes(legCode) {
  return {
    type: ALL_TRANSPORT_MODES_DE_SELECTED,
    legCode,
  };
}
